export const CUSTOMER_PURCHASED_SUBSCRIPTIONS_RQ_KEY = "CUSTOMER_PURCHASED_SUBSCRIPTIONS";

export const GET_CUSTOMER_PURCHASED_SUBSCRIPTION_RQ_KEY =
  "GET_CUSTOMER_PURCHASED_SUBSCRIPTION";
